export const routes = [
  {
    path: '/v-numeratori',
    name: 'Numeratori',
    component: () => import(/* webpackChunkName: "numeratori" */ '../views/numeratori')
  }  
]
